
class FeaturedProduct extends HTMLElement {
    variantPicker; btn; feedback;
    static selectors = {
      add: '[data-add]',
    };
  
    constructor(){
      super();
      this.init();
    }
  
    init = () => {
      this.variantPicker = this.querySelector('variant-picker');
      this.btn = this.querySelector(FeaturedProduct.selectors.add);
  
      if(this.variantPicker != undefined){
        this.variantPicker.addEventListener(Utils.VARIANT_CHANGED, (e, data) => {
          this.refreshVariant(e.detail.variant);
        });
      }
      if(this.btn != undefined){
        this.btn.addEventListener('click', () => {
          this.addToCart();
        });
      }
    }
  
    refreshVariant = (variant) => {
      window.pageLoader.open();
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      axios.get(url.href).then((response) => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(response.data, 'text/html');
        this.innerHTML = doc.querySelector('main-product').innerHTML;
        this.setUrl(variant.id);
        this.init();
      })
      .catch(function(error) {
        Utils.error(error.message, error);
      })
      .finally(() => {
        window.pageLoader.close();
      });
    }
  
    setUrl = (variantid) => {
      const params = new URLSearchParams(window.location.search);
      const title = document.querySelector('title').innerText;
      params.set('variant', variantid);
      window.history.replaceState({}, title, `${window.location.pathname}?${params}`);
    }
  
    addToCart = () => {
      Utils.addTocart({
        form: this.querySelector('form'),
        beforeAdd: (id) => {
          window.pageLoader.open();
        },
        finally: () => {
          window.pageLoader.close();
        }
      });
    }
  }
  if (!window.customElements.get("featured-product")) {
    window.customElements.define("featured-product", FeaturedProduct);
  }